import React from 'react';

import { margin } from '@lumapps/classnames';
import { GapSize, GlobalSize, Size, SkeletonRectangle, SkeletonTypography } from '@lumapps/lumx/react';
import { UseMetadataListWithSelected } from '@lumapps/metadata-pickers/hooks/useMetadataListWithSelected';

import { FormMetadataField, type FormMetadataFieldProps } from '../FormMetadataField';
import { FormSubSection, FormSubSectionProps } from '../FormSubSection';

export interface FormMetadataFieldsetProps extends FormSubSectionProps {
    /** metadatas to display */
    metadatas?: UseMetadataListWithSelected;
    /** gap to be used between fields */
    gap: GapSize;
    /** whether the each field should show multiple levels or just the first one */
    showMultipleLevels?: boolean;
    /** props passed to each MetadataField */
    metadataFieldProps?: Partial<FormMetadataFieldProps>;
}

export const FormMetadataFieldset: React.FC<FormMetadataFieldsetProps> = ({
    metadatas,
    gap,
    showMultipleLevels,
    metadataFieldProps,
    ...props
}) => {
    if (metadatas && metadatas.isLoading) {
        return (
            <>
                <SkeletonTypography typography="body1" width="300px" className={margin('bottom')} />
                <SkeletonRectangle width={'100%' as GlobalSize} height={Size.m} className={margin('bottom', 'big')} />
                <SkeletonTypography typography="body1" width="300px" className={margin('bottom')} />
                <SkeletonRectangle width={'100%' as GlobalSize} height={Size.m} />
            </>
        );
    }

    if (metadatas && metadatas.hasLoaded && !metadatas.hasError && metadatas.parentMetadatas.length > 0) {
        return (
            <FormSubSection {...props} contentWrapperProps={{ gap, ...props.contentWrapperProps }}>
                {metadatas.parentMetadatas.map((parentMetadata) => {
                    return (
                        <FormMetadataField
                            name={`metadatas.${parentMetadata.id}`}
                            key={parentMetadata.id}
                            family={parentMetadata}
                            controllerProps={{ defaultValue: metadatas.selectedMetadatas[parentMetadata.id] }}
                            showMultipleLevels={showMultipleLevels}
                            {...metadataFieldProps}
                        />
                    );
                })}
            </FormSubSection>
        );
    }

    return null;
};
